import i18next from "src/i18n/config";
import RouteService from "src/services/routeService";
import { transformErrorResponse } from "src/store/helpers";
import { PaginatedResponse } from "src/types";

import { FeatureTypeValue } from "@dashboard/workspaces/types";
import { toBackendPageIndex } from "@shared/table/Tanstack.utils";

import { AdminBuilder } from "./tags";

type GetAllWorkspacesParams = {
    pageSize?: number;
    pageIndex?: number;
    sortCriteria?: string;
    sortDirection?: string;
    fromExpirationDate?: string;
    toExpirationDate?: string;
    includeTerminated?: boolean;
    billingType?: "manual" | "paypal" | "stripe";
    featureType?: FeatureTypeValue;
    minFeatureValue?: number;
};

const workspaces = (builder: AdminBuilder) => ({
    getAllWorkspaces: builder.query<{ list: API.Workspace[]; count: number }, GetAllWorkspacesParams>({
        providesTags: ["AdminWorkspaces"],
        transformErrorResponse: (err) => transformErrorResponse(err, i18next.t("common:error.technicalDifficulties.message")),
        transformResponse: (response: PaginatedResponse<API.Workspace>) => ({ list: response.list, count: response.count }),
        query: async (params) => {
            const base = await RouteService.getWorkspacesRoute();
            return {
                url: `${base}all`,
                headers: { "content-type": "application/json" },
                params: {
                    PageIndex: toBackendPageIndex(params.pageIndex),
                    PageSize: params.pageSize,
                    SortCriteria: params.sortCriteria,
                    SortDirection: params.sortDirection,
                    FromExpirationDate: params.fromExpirationDate,
                    ToExpirationDate: params.toExpirationDate,
                    IncludeTerminated: params.includeTerminated,
                    BillingType: params.billingType,
                    FeatureType: params.featureType,
                    MinFeatureValue: params.minFeatureValue,
                },
            };
        },
    }),
});

export default workspaces;
